import FeedbackSettingsDialog from 'components/CreateAssignment/FeedbackSettingsDialog';
import CreationHeader from 'components/CreateQuiz/CreationHeader';
import RubricDialogs from 'components/CreateQuiz/RubricDialogs';
import { useViewport } from 'contexts/viewport';
import Desktop from 'pages/CreateQuiz/desktop';
import Mobile from 'pages/CreateQuiz/mobile';
import { PageContext } from 'pages/CreateQuiz/PageProvider';
import Tablet from 'pages/CreateQuiz/tablet';
import { useContext } from 'react';
import { Stack } from 'shell/components';

const PageLayout = () => {
    const { device } = useViewport();
    const { form, feedbackDialogOpen, setFeedbackDialogOpen, handleSaveFeedback } = useContext(PageContext);

    return (
        <Stack sx={(theme) => ({ minHeight: '100%', background: theme.palette.ensightful.shades[0] })}>
            <CreationHeader />
            {{ desktop: <Desktop />, tablet: <Tablet />, mobile: <Mobile /> }[device]}
            <RubricDialogs />
            <FeedbackSettingsDialog
                isQuizFeedback
                open={feedbackDialogOpen}
                form={form}
                onClose={() => setFeedbackDialogOpen(false)}
                onSave={handleSaveFeedback}
            />
        </Stack>
    );
};

export default PageLayout;
